import React from 'react';
import PropTypes from 'prop-types';
import { JOURNEY_STEP_TYPE } from '../../../../services/utilityFunctions';
import Anchor from '../../../../commonComponents/Anchor';
import translate from '../../../../commonComponents/translate';
import JourneyProp from '../../propTypes/journeyProp';
import JourneyPathItem from './JourneyPathItem';
import JourneyPathTrophy from './JourneyPathTrophy';
import JourneyProgress from '../JourneyProgress';

function JourneyPath(props) {
  const { t, journey, showEnrollOverlay, navigateOnClick, onSelection } = props;

  const image = journey.image
    ? journey.image.url
    : '/images/no_image_upload.png';

  const steps = journey.steps || [];
  const half = Math.ceil(steps.length / 2);
  const firstHalf = steps.slice(0, 5);
  const secondHalf = steps.slice(5);

  const navigate = stepId => {
    if (navigateOnClick) {
      window.location.href = `/journey/${journey.slug}?step=${stepId}`;
    } else if (onSelection) {
      onSelection(stepId);
    }
  };
  const handleClick = navigateOnClick || onSelection ? navigate : null;

  return (
    <div
      className="m-portlet m-portlet--rounded m-portlet--rounded-force"
      style={{ position: 'relative' }}
    >
      {showEnrollOverlay && <div className="enroll-overlay" />}
      <div className="m-portlet__body journey-path">
        <div className="row">
          <div className="col-lg-9">
            <h2>{journey.title}</h2>
          </div>
          <div className="col-lg-3">
            <JourneyProgress progress={journey.progress} />
          </div>
          <div className="col-lg-12">
            <hr />
            <br />
          </div>
          <div className="col-lg-4 col-md-4 journey-path-left">
            {firstHalf.map(
              (step, index) =>
                step.type === JOURNEY_STEP_TYPE.TROPHY ? (
                  <JourneyPathTrophy key={step._id} step={step} />
                ) : (
                  <JourneyPathItem
                    key={step._id}
                    step={step}
                    index={index}
                    onClick={handleClick}
                  />
                ),
            )}
          </div>
          <div className="col-lg-4 col-md-4 journey-path-middle">
            <img src={image} alt="journey" />
            {navigateOnClick && (
              <div className="col-lg-12 journey-path-continue-container">
                <Anchor
                  className="btn m-btn--pill btn-dynamic"
                  href={`/journey/${journey.slug}`}
                >
                  {t('landing_journey_all_btn')}
                </Anchor>
              </div>
            )}
          </div>
          <div className="col-lg-4 col-md-4 journey-path-right">
            {secondHalf.map(
              (step, index) =>
                step.type === JOURNEY_STEP_TYPE.TROPHY ? (
                  <JourneyPathTrophy key={step._id} flipped step={step} />
                ) : (
                  <JourneyPathItem
                    key={step._id}
                    flipped
                    step={step}
                    index={index + half}
                    onClick={handleClick}
                  />
                ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

JourneyPath.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  showEnrollOverlay: PropTypes.bool,
  navigateOnClick: PropTypes.bool,
  onSelection: PropTypes.func,
};

JourneyPath.defaultProps = {
  showEnrollOverlay: false,
  navigateOnClick: false,
  onSelection: null,
};

export default translate(JourneyPath);
